/**
 * Sequential reader over a byte buffer.
 *
 * @module qtdatastream-web/buffer
 */
import { toUint8 } from './bytes.js';
/**
 * Wraps a byte buffer with an internal read pointer for sequential reads.
 * All integer reads are big-endian, matching Qt's QDataStream format.
 */
export class ReadBuffer {
    buffer;
    view;
    read_offset;
    constructor(input) {
        this.buffer = toUint8(input);
        this.view = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
        this.read_offset = 0;
    }
    /** Remaining unread bytes as a view, or `null` if the buffer is exhausted. */
    remaining() {
        if (this.read_offset >= this.buffer.byteLength)
            return null;
        return this.buffer.subarray(this.read_offset);
    }
    readInt8() {
        const result = this.view.getInt8(this.read_offset);
        this.read_offset += 1;
        return result;
    }
    readInt16BE() {
        const result = this.view.getInt16(this.read_offset, false);
        this.read_offset += 2;
        return result;
    }
    readUInt16BE() {
        const result = this.view.getUint16(this.read_offset, false);
        this.read_offset += 2;
        return result;
    }
    readInt32BE() {
        const result = this.view.getInt32(this.read_offset, false);
        this.read_offset += 4;
        return result;
    }
    readUInt32BE() {
        const result = this.view.getUint32(this.read_offset, false);
        this.read_offset += 4;
        return result;
    }
    readInt64BE() {
        const result = this.view.getBigInt64(this.read_offset, false);
        this.read_offset += 8;
        return result;
    }
    readUInt64BE() {
        const result = this.view.getBigUint64(this.read_offset, false);
        this.read_offset += 8;
        return result;
    }
    readDoubleBE() {
        const result = this.view.getFloat64(this.read_offset, false);
        this.read_offset += 8;
        return result;
    }
    /** Read `size` bytes as a view (shares memory with the underlying buffer). */
    slice(size) {
        const result = this.buffer.subarray(this.read_offset, this.read_offset + size);
        this.read_offset += size;
        return result;
    }
}
//# sourceMappingURL=buffer.js.map